import { createContext } from 'react';
import { ScheduleState } from '../types';
import { defaultState } from './reducer';

const Context = createContext<ScheduleState>({
  ...defaultState,
});

export default Context;
